<script>
  import { onMount } from 'svelte';

  export let onscrub = (mx, my, wp, hp) => {},
    current = 0,
    max = 100;

  let scrubber,
    scrubberHandle,
    width = 0,
    minWidth = 10,
    scrubberWidth,
    currentTimeDisplay = '',
    maxTimeDisplay = '';

  function getScrubberPosition(e) {
    const bb = e.target.getBoundingClientRect();
    const mx = e.clientX - bb.left;
    onscrub((mx / getMaxWidth()) * max);
  }

  function getWidth() {
    if (!scrubberHandle) return 0;
    const bb = scrubberHandle.getBoundingClientRect();
    return bb.right - bb.left;
  }

  function getMaxWidth() {
    if (!scrubber) return 1;
    const bb = scrubber.getBoundingClientRect();
    return bb.right - bb.left;
  }
  function relativeProgress() {
    const p = current / max;
    const min = minWidth / getMaxWidth();
    const w = getWidth();
    return (p <= min ? min : p) * 100;
  }

  function secsToMin(secs) {
    const m = Math.floor(secs / 60), s = Math.floor(secs % 60);
    return `${m}:${('00' + s).slice(-2)}`;
  }

  function draw() {
    scrubberWidth = relativeProgress();
    currentTimeDisplay = secsToMin(current);
    maxTimeDisplay = secsToMin(max);
  }

  onMount(draw);

  setInterval(draw, 500);
</script>

<div class="video-scrubber-wrapper">
  <div class="scrubber-time">
    <div class="scrubber-time-wrapper">
      <div class="st-current">{currentTimeDisplay}</div>
      <div class="st-max">{maxTimeDisplay}</div>
    </div>
  </div>
  <div class="scrubber-container">
    <div on:mouseup|stopPropagation={getScrubberPosition} class="scrubber" bind:this={scrubber}>
      <div class="scrubber-handle" style="width:{scrubberWidth}%" bind:this={scrubberHandle} />
    </div>
  </div>
</div>